import "slick-carousel";

import "slick-carousel/slick/slick.css";

$(document).ready(() => {
  // product image sliders
  $(".images__large").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    rows: 0,
    fade: true,
    asNavFor: $(".images__small")
  });

  const imagesSmallSlickOpts = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: $(".images__large"),
    dots: true,
    appendDots: $(".images-sm-dots"),
    centerMode: true,
    arrows: false,
    rows: 0,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };
  $(".images__small").slick(imagesSmallSlickOpts);

  // hide sm images if only one
  $(".slick-track li:only-child")
    .closest(".images__small")
    .hide();
  $(".slick-dots li:only-child")
    .closest(".images-sm-dots")
    .hide();

  // related carousel
  $("#related").slick({
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    rows: 0,
    prevArrow: $("#relatedPrev"),
    nextArrow: $("#relatedNext"),
    appendDots: $("#relatedDots"),
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575.98,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
